/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';

@Component({
    selector: 'app-pages-cms',
    templateUrl: './cms.component.html',
    styleUrls: ['./cms.component.scss'],
})
export class PagesCmsComponent { }
